import React from 'react';

import OrganizationContextProvider from '@usas/ui-web/state/organization/OrganizationContextProvider';
import CourseContextProvider from '@usas/ui-web/state/course/CourseContextProvider';
import OrgUnitContextProvider from '@usas/ui-web/state/orgUnit/OrgUnitContextProvider';
import LscContextProvider from '@usas/ui-web/state/lsc/LscContextProvider';
import MeetClassificationContextProvider from '@usas/ui-web/state/meet/meetClassification/MeetClassificationContextProvider';
import BPMeetClassificationContextProvider from '@usas/ui-web/state/meet/blockPartyMeetClassification/BPMeetClassificationContextProvider';
import MeetClassificationTypeContextProvider from '@usas/ui-web/state/meet/meetClassificationType/MeetClassificationTypeContextProvider';
import MeetSoftwareContextProvider from '@usas/ui-web/state/meet/meetSoftware/MeetSoftwareContextProvider';
import EventContextProvider from '@usas/ui-web/state/event/EventContextProvider';
import FacilityContextProvider from '@usas/ui-web/state/facility/FacilityContextProvider';

const AppStateContextProviders = ({ children }) => {

  return (
    <OrganizationContextProvider>
      <OrgUnitContextProvider>
        <CourseContextProvider>
          <LscContextProvider>
            <MeetClassificationContextProvider>
              <MeetClassificationTypeContextProvider>
                <BPMeetClassificationContextProvider>
                  <MeetSoftwareContextProvider>
                    <EventContextProvider>
                      <FacilityContextProvider>
                        {children}
                      </FacilityContextProvider>
                    </EventContextProvider>
                  </MeetSoftwareContextProvider>
                </BPMeetClassificationContextProvider>
              </MeetClassificationTypeContextProvider>
            </MeetClassificationContextProvider>
          </LscContextProvider>
        </CourseContextProvider>
      </OrgUnitContextProvider>
    </OrganizationContextProvider>
  );
};
export default AppStateContextProviders;